import styled from 'styled-components'
import Flex from 'elements/Flex'

export const Grid = styled.div`
  column-gap: 3.75rem;
  display: grid;
  grid-auto-columns: auto;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  height: auto;
  justify-items: center;
  margin: 24px;
  padding-top: 24px;
  row-gap: 2rem;
`

export const Tabs = styled.div`
  display: flex;
  font-family: 'Rubik';
  font-size: 20px;
  font-weight: 400;
`

export const TabItem = styled.div<{ active?: boolean }>`
  color: ${props => (props.active ? '#D06CFF' : '#FFF')};
  cursor: pointer;
  font-weight: 500;
  opacity: ${props => (props.active ? 1 : 0.4)};
  padding-right: 16px;
  transition: all 0.35s;

  &:hover {
    color: ${props => !props.active && 'FFF'};
    opacity: ${props => !props.active && 1};
  }
`

export const Option = styled.li`
  font-size: 18px;
  &:hover {
    background-color: #363942;
    cursor: pointer;
    transition: none;
  }
  padding: 8px;
`

export const Selection = styled.ul<{ openTab: boolean; many: number }>`
  background-color: #222429;
  border-radius: 0px 0px 8px 8px;
  height: ${props => (props.openTab ? `calc(40px * ${props.many})` : 0)};
  list-style: none;
  margin: 0;
  opacity: ${props => (props.openTab ? 1 : 0)};
  padding: 0;
  position: absolute;
  text-align: center;
  transition: opacity 0.25s ease, height 0.35s ease, visibility 0.25s ease;
  visibility: ${props => (props.openTab ? 'visible' : 'hidden')};
  width: 100%;
  z-index: 3;
  &:hover {
    transition: none;
  }
  ${Option} {
    height: ${props => (props.openTab ? '35px' : 0)};
    transition: all 0.25s ease;
    &:hover {
      transition: none;
    }
  }
`

export const RelativeWrapper = styled.div`
  position: relative;
  z-index: 3;
`

export const SelectionTitle = styled.div<{ openTab: boolean }>`
  background-color: #222429;
  border-radius: ${props => (props.openTab ? '8px 8px 0 0' : '8px')};
  font-size: 18px;
  padding: 8px 5px;
  text-align: center;
  transition: 0.35s;
  &:hover {
    background-color: #363942;
    cursor: pointer;
    transition: none;
  }
`

export const Padder = styled.div`
  padding: 0 20px;
`

export const Card = styled.div`
  height: auto;
  color: #fff;
  margin-right: 8px;
  width: auto;
  &:hover {
    cursor: pointer;
  }
`

export const RoundedImg = styled.img`
  border-radius: 8px;
  height: 80px;
  object-fit: cover;
  width: 80px;
`

export const ProfileImgWrapper = styled.div`
  height: 100%;
  width: 80%;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-right: 0;
    text-align: center;
    width: 100%;
  `}
`

export const ProfileName = styled.div`
  color: #868992;
  font-size: 20px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    text-align: center;
  `}
`

export const ProfileRole = styled.div`
  background: #434958;
  border-radius: 8px;
  font-family: 'Rubik';
  font-weight: 400;
  margin-top: 12px;
  padding: 8px 10px;
  text-align: center;
  width: 120px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: auto;
    margin-top: 18px;
  `}
`

export const ProfileIdentity = styled.div`
  font-size: 24px;
  padding: 10px 0;
`

export const ProfileWrapper = styled.div`
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 0;
    padding: 0 12px;
  `}
`

export const Quote = styled.div`
  font-size: 32px;
  font-style: italic;
  margin-top: 80px;
`

export const TRow = styled.tr`
  font-family: 'Rubik';
  font-size: 20px;
  font-weight: 400;

  td {
    padding-bottom: 18px;
    width: 100px;
  }

  td:first-child {
    color: #868992;
  }

  td:nth-child(2) {
    color: #868992;
  }

  td:last-child {
    width: 500px;
  }
`

export const StyledFollowersNumber = styled.h3`
  font-size: 64px;
  font-weight: 700;
  margin-right: 24px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 36px;
  `}
`

export const StyledSocMedPlatform = styled.h3`
  font-size: 36px;
  font-weight: 700;
  text-transform: uppercase;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 24px;
  `}
`

export const StyledSymbol = styled.h3`
  background: #121626;
  border-radius: 8px;
  color: #d06cff;
  display: flex;
  font-size: 36px;
  font-weight: 700;
  margin-right: 24px;
  padding: 8px 14px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 24px;
  `}
`

export const TeamRole = styled.div`
  background-color: #121626;
  border-radius: 8px;
  padding: 8px 10px;
`

export const Ign = styled.div`
  font-size: 24px;
  font-weight: bold;
  padding-top: 8px;
`

export const Name = styled(Flex)`
  color: #868992;
  font-size: 16px;
  font-weight: 400;
  padding-top: 24px;
`

export const ProfileFooter = styled.div`
  position: absolute;
`

export const SocialMediaWrapper = styled.div`
  margin-left: 9px;
  padding-bottom: 24px;
`

export const ProfileIgn = styled.div`
  color: white;
  font-size: 46px;
  font-weight: 700;
  padding-top: 12px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    text-align: center;
  `}
`

export const QuoteWrap = styled.div`
  background-color: #121626;
  border-radius: 8px;
  display: inline-block;
  font-family: 'Rubik';
  font-size: 20px;
  font-weight: 400;
  margin-top: 24px;
  padding: 18px;
  position: relative;
`
export const QuoteWrapper = styled.div`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: flex;
    justify-content: center;
  `}
`

export const ResponsiveFlex = styled.div`
  display: flex;
  padding-top: 30px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-direction: column;
  `}
`

export const ProfileNameWrap = styled.div`
  align-items: center;
  display: flex;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-content: center;
  `}
`

export const HoverEffect = styled.div`
  color: #fff;
  font-size: 36px;
  font-weight: 500;
  opacity: 0;
  transition: all 0.35s;
  word-spacing: 1.5px;
  &:hover {
    cursor: pointer;
    opacity: 1;
  }
`
export const Backer = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  transition: all 0.5s;
  width: 150px;
  svg:hover + ${HoverEffect} {
    opacity: 1;
  }
`
export const ProfileImg = styled.img`
  display: block;
  margin: 0 auto;
  max-height: 28em;
  ${({ theme }) => theme.mediaWidth.upToMedium`
      display: block;
      margin: 0 auto;
      max-width: 80%;
    `}
`
export const RoleBoxProfileWrapper = styled.div`
  svg {
    display: block;
    height: auto;
    margin: 0 auto 0;
    width: 20em;
    ${({ theme }) => theme.mediaWidth.upToLarge`
      display: block;
      margin: 0 auto 0;
      width: 16em;
      height: auto;
    `}
    ${({ theme }) => theme.mediaWidth.upToMedium`
      display: block;
      margin: 0 auto 0;
      width: 14em;
      height: auto;
    `}
  }
`
export const NameWrapperDesktop = styled.div`
  ${({ theme }) => theme.mediaWidth.upToSmall`
      display: none;
    `}
`

export const NameWrapperMobile = styled.div`
  display: none;
  ${({ theme }) => theme.mediaWidth.upToSmall`
      display: block;
    `}
`
export const StyledLink = styled.a`
  color: #fff;
  text-decoration: none;
  width: fit-content;
  display: flex;
`
export const BannerWrapper = styled.div`
  display: flex;
  margin-bottom: 24px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    display: none;
  `}
`

export const CardOverlay = styled.div`
  /* width: 10px;
  height: 10px;
  position: absolute;
  border-radius: 12px;
  background: #e3a9fe;
  top: 41px;
  left: 116px;
  z-index: 0;
  transition: all 0.3s ease-out; */
`

export const CardImg = styled.img`
  height: 238px;
  margin-left: -30px;
  position: relative;
  transition: ${({ theme }) => `transform ${theme.TRANSITION.medium} ease-in-out`};
`

export const CardContent = styled.div`
  position: relative;
  display: flex;
  width: 280px;
  transition: ${({ theme }) => `all ${theme.TRANSITION.medium} ease-in-out`};
  svg {
    transition: ${({ theme }) => `transform ${theme.TRANSITION.slow} ease-in-out`};
    path {
    }
  }

  &:hover {
    transform: translateY(-10px) scale(1.1) translateZ(0);
    .team-card {
      transform: rotateY(360deg);
    }
    /* img {
      transform: rotateY(-360deg);
    } */
    /* svg {
      transform: translateZ(0);
      path {
        transform: translateZ(0);
      }
      #path-to-change {
        fill: #f198ff;
      }
      #path-to-change-2 {
        fill: #e3a9fe;
      }
    } */
  }
`

/* .overlay {
        width: 118px;
        height: 118px;
        transform: scale(4) translateZ(0);
        z-index: 0;
        background: #e3a9fe;
      } */
